<template>
    <md-dialog ref="maintenanceNotice" @open="opened" @close="closed" class="maintenance-notice-modal">
        <md-dialog-title>
            <div class="modal-title">Notice</div>
        </md-dialog-title>
        <md-dialog-content class="maintenance-notice-modal-content">
            <div class="maintenance-message">
                <p>Due to an urgent, mandatory maintenance requirement our site is currently unable to process new payments. We are working hard on the issue and expect a resolution within <b>48 hours</b>. If you need immediate attention due to this, please reach out to <a href="mailto:info@thecuelist.com">info@thecuelist.com</a> for help. Thank you for your patience!</p>
            </div>
        </md-dialog-content>
        <md-dialog-actions>
            <md-button class="md-primary md-raised" @click="closeDialog">OK</md-button>
        </md-dialog-actions>
    </md-dialog>
</template>

<script>
const MaintenanceNotice = {
    name: 'maintenanceNotice',
    methods: {
        open() {
            this.$refs.maintenanceNotice.open();
        },
        closeDialog() {
            this.$refs.maintenanceNotice.close();
        },
        opened() {
            this.$emit('open');
        },
        closed() {
            this.$emit('close');
        }
    }
};
export default MaintenanceNotice;
</script>

<style lang="scss">
.maintenance-notice-modal {
    .md-dialog {
        width: 500px;
        max-width: 90vw;
    }
    .md-dialog-title {
        background: #081e4f;
        line-height: 1.4;
        text-align: center;
        color: white;
        padding: 1rem;
        
        .modal-title {
            font-size: 24px;
            font-weight: 600;
        }
    }
    .maintenance-notice-modal-content {
        padding: 2rem;
        
        .maintenance-message {
            font-size: 16px;
            line-height: 1.6;
            color: #333;
            
            p {
                margin: 0;
            }
            
            a {
                color: rgb(22, 143, 177);
                text-decoration: none;
                
                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }
    .md-dialog-actions {
        padding: 1rem;
        justify-content: center;
        
        .md-button {
            min-width: 120px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// maintenance-notice.vue?2e8b76e7